












































import Vue from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import Button from '@/components/form/Button.vue';

export default Vue.extend({
  name: 'TheSettings',
  components: { WidgetWrapper, FieldInput, Button },

  methods: {
    async submit() {
      if (!this.validate()) return;

      const formData = new FormData();

      if (this.password.current) {
        formData.append('password', this.password.current);
      }

      if (this.password.new) {
        formData.append('new_password', this.password.new);
      }

      const response = await this.$store.dispatch('changePassword', formData);

      if (response.success) {
        window.location.href = '/';
      } else {
        if (response.data.length) {
          response.data.forEach((error) => {
            this.setErrors(error.field, error.message);
          });
        }
      }
    },
    validate() {
      this.resetErrors();
      let success = true;

      if (this.password.current && !this.password.new) {
        this.setErrors('new', this.$t('errors.requiredNewPassword'));
        success = false;
      }

      if (this.password.current && !this.password.confirm) {
        this.setErrors('confirm', this.$t('errors.requiredConfirmPassword'));
        success = false;
      }

      if (
        this.password.new &&
        this.password.confirm === '' &&
        this.password.current === ''
      ) {
        this.setErrors('current', this.$t('errors.requiredOldPassword'));
        this.setErrors('confirm', this.$t('errors.requiredConfirmPassword'));
        success = false;
      }

      if (
        this.password.confirm &&
        this.password.new === '' &&
        this.password.current === ''
      ) {
        this.setErrors('current', this.$t('errors.requiredOldPassword'));
        this.setErrors('new', this.$t('errors.requiredNewPassword'));
        success = false;
      }

      if (
        (this.password.new || this.password.confirm) &&
        this.password.current === ''
      ) {
        this.setErrors('current', this.$t('errors.requiredOldPassword'));
        success = false;
      }

      if (this.password.current && this.password.new && this.password.confirm) {
        if (this.password.new !== this.password.confirm) {
          this.setErrors('new', this.$t('errors.matchPassword'));
          this.setErrors('confirm', this.$t('errors.matchPassword'));
          success = false;
        }
      }

      if (
        this.password.new &&
        this.password.confirm &&
        !this.password.current
      ) {
        if (this.password.new !== this.password.confirm) {
          this.setErrors('new', this.$t('errors.matchPassword'));
          this.setErrors('confirm', this.$t('errors.matchPassword'));
          success = false;
        }
      }

      if (this.password.current === this.password.new) {
        this.setErrors('new', this.$t('errors.notNewPassword'));
        success = false;
      }

      return success;
    },
    setErrors(name, value) {
      if (this.errors[name].indexOf(value) == -1) {
        this.errors[name].push(value);
      }
    },
    resetErrors() {
      this.errors.current = [];
      this.errors.new = [];
      this.errors.confirm = [];
    },
  },

  data() {
    return {
      password: {
        current: '',
        new: '',
        confirm: '',
      },
      errors: {
        current: [],
        new: [],
        confirm: [],
      },
    };
  },
});
